import { render, staticRenderFns } from "./StrapiMentionsLegalesView.vue?vue&type=template&id=59fdb463"
import script from "./StrapiMentionsLegalesView.vue?vue&type=script&lang=js"
export * from "./StrapiMentionsLegalesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports